(function () {
  // IMPORTANT: do NOT block re-init across swaps
  // Only prevent double-installing the global listeners once.
  if (window.__rhFabricGlobalInstalled) return;
  window.__rhFabricGlobalInstalled = true;

  function buildUrl(baseUrl, extraParams) {
    const u = new URL(baseUrl, window.location.origin);
    for (const [k, v] of Object.entries(extraParams || {})) {
      if (v === undefined || v === null || v === "") continue;
      u.searchParams.set(k, String(v));
    }
    return u.toString();
  }

  function getHeroExcludeId(scope) {
    const hero = (scope || document).querySelector("#fabric-hero");
    if (!hero) return "";
    const a = hero.querySelector(".fabric-item[data-collection-id]");
    const id = a && a.getAttribute("data-collection-id");
    return id && /^\d+$/.test(id) ? id : "";
  }

  function getEl(scope) {
    return (scope || document).querySelector("#fabric-swatches[data-fabric-api]");
  }

  // Abort in-flight summary fetch when product changes quickly
  let activeController = null;

  async function renderSummary(scope) {
    const el = getEl(scope);
    if (!el) return;

    const apiBase = (el.getAttribute("data-fabric-api") || "").trim();
    if (!apiBase) return;

    const excludeFabricId = getHeroExcludeId(scope);

    // Don’t re-render if already rendered for this apiBase + exclude id
    const key = apiBase + "::" + excludeFabricId;
    if (el.dataset.rhKey === key && el.dataset.rhLoaded === "1") return;

    // abort old
    if (activeController) {
      try { activeController.abort(); } catch(e) {}
    }
    activeController = new AbortController();

    el.dataset.rhLoaded = "0";
    el.dataset.rhKey = key;

    const summaryUrl = buildUrl(apiBase, { excludeFabricId });

    try {
      const res = await fetch(summaryUrl, {
        credentials: "same-origin",
        signal: activeController.signal
      });
      if (res.ok) {
        el.innerHTML = await res.text();
        el.dataset.rhLoaded = "1";
      }
    } catch (err) {
      if (err && err.name === "AbortError") return;
      console.warn("[RH Fabric] summary fetch failed", err);
    }

    bindToggleOnce(el);
  }

  function bindToggleOnce(el) {
    if (!el || el.dataset.rhToggleBound === "1") return;
    el.dataset.rhToggleBound = "1";

    el.addEventListener("toggle", async (e) => {
      const d = e.target;
      if (!(d instanceof HTMLDetailsElement)) return;
      if (!d.open) return;

      const body = d.querySelector(".fs-group-body");
      if (!body) return;

      if (body.getAttribute("data-loaded") === "1") return;
      body.setAttribute("data-loaded", "1");

      const groupId = d.getAttribute("data-group-id");
      if (!groupId) return;

      const hostEl = document.querySelector("#fabric-swatches[data-fabric-api]");
      if (!hostEl) return;

      const apiBase = (hostEl.getAttribute("data-fabric-api") || "").trim();
      if (!apiBase) return;

      const excludeFabricId = getHeroExcludeId(document);

      const groupUrl = buildUrl(apiBase, {
        group: groupId,
        format: "html",
        excludeFabricId
      });

      try {
        const gr = await fetch(groupUrl, { credentials: "same-origin" });
        if (gr.ok) body.innerHTML = await gr.text();
      } catch (err) {
        console.warn("[RH Fabric] group fetch failed", err);
      }
    }, true);
  }

  // Debounced re-init (so multiple mutations/events don’t spam)
  let t = null;
  function scheduleInit() {
    if (t) clearTimeout(t);
    t = setTimeout(() => renderSummary(document), 50);
  }

  // 1) Initial
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scheduleInit);
  } else {
    scheduleInit();
  }

  // 2) Catch SPA-style swaps (Combined Listings often uses fetch + replace + history API)
  const _pushState = history.pushState;
  history.pushState = function () {
    const r = _pushState.apply(this, arguments);
    scheduleInit();
    return r;
  };
  const _replaceState = history.replaceState;
  history.replaceState = function () {
    const r = _replaceState.apply(this, arguments);
    scheduleInit();
    return r;
  };
  window.addEventListener("popstate", scheduleInit);

  // 3) Common Shopify theme events (Dawn + section rendering)
  document.addEventListener("variant:change", scheduleInit);
  document.addEventListener("product:change", scheduleInit);
  document.addEventListener("shopify:section:load", scheduleInit);

  // 4) Last-resort: observe DOM changes
  const root = document.querySelector("main") || document.querySelector("#MainContent") || document.body;
  if (root) {
    const mo = new MutationObserver(() => {
      // Only init if fabric-swatches exists (cheap check)
      if (document.querySelector("#fabric-swatches[data-fabric-api]")) scheduleInit();
    });
    mo.observe(root, { childList: true, subtree: true });
  }
})();



(function () {
  const WRAPPER_SEL = "#fabrics";
  const SWATCH_SEL = `${WRAPPER_SEL} a.fabric-item[data-price-group]`;

  const CHOSEN_FABRIC_SWATCH = "#fabric-chosen-img > img";
  const CHOSEN_FABRIC = "#fabric-chosen-code";

  const H_FABRIC = "#selected_fabric";
  const H_THUMB  = "#selected_fabric_thumbnail";
  const H_CODE   = "#selected_color-code";

  let activePriceGroupLock = null;

  function normalize(v) {
    return String(v || "").trim().toUpperCase();
  }

  function fireChange(el) {
    if (!el) return false;

    el.dispatchEvent(new Event("input", { bubbles: true }));
    el.dispatchEvent(new Event("change", { bubbles: true }));

    return true;
  }

  function getScope(el) {
    return (
      el.closest(".product__info-wrapper") ||
      el.closest('section[id^="shopify-section-"]') ||
      el.closest('form[action^="/cart/add"]') ||
      document
    );
  }

  function escId(id) {
    return (window.CSS && CSS.escape)
      ? CSS.escape(id)
      : String(id).replace(/"/g, '\\"');
  }

  function findSelectByExactLabel(scope, labelText) {
    const want = normalize(labelText.replace(/:$/, ""));
    const labels = Array.from(scope.querySelectorAll("label[for]"));

    const label = labels.find(function (l) {
      return normalize(l.textContent.replace(/:$/, "")) === want;
    });

    if (!label) return null;

    const id = label.getAttribute("for");
    if (!id) return null;

    const el = scope.querySelector(`#${escId(id)}`);
    return el && el.tagName === "SELECT" ? el : null;
  }

  function findPriceGroupSelect(scope) {
    return (
      scope.querySelector('select[name="options[Price Group]"], select[name="options[Price Group]" i]') ||
      scope.querySelector('select[data-option-name="Price Group"], select[data-option-name="Price Group" i]') ||
      findSelectByExactLabel(scope, "Price Group")
    );
  }

  function getMatchingPriceGroupOption(sel, groupRaw) {
    if (!sel) return null;

    const g = normalize(groupRaw);
    if (!g) return null;

    const opts = Array.from(sel.options || []);

    return (
      opts.find(o => normalize(o.value) === g || normalize(o.textContent) === g) ||
      opts.find(o => normalize(o.value) === `PRICE GROUP ${g}` || normalize(o.textContent) === `PRICE GROUP ${g}`) ||
      opts.find(o => normalize(o.value).endsWith(` ${g}`) || normalize(o.textContent).endsWith(` ${g}`)) ||
      null
    );
  }

  function setPriceGroup(scope, groupRaw) {
    const sel = findPriceGroupSelect(scope);
    if (!sel) return false;

    const match = getMatchingPriceGroupOption(sel, groupRaw);
    if (!match) return false;

    if (sel.value !== match.value) {
      sel.value = match.value;
    }

    return fireChange(sel);
  }

  function priceGroupIsCorrect(scope, groupRaw) {
    const sel = findPriceGroupSelect(scope);
    if (!sel) return false;

    const match = getMatchingPriceGroupOption(sel, groupRaw);
    if (!match) return false;

    return sel.value === match.value;
  }

  function lockPriceGroupAfterFabricClick(scope, groupRaw) {
    const sel = findPriceGroupSelect(scope);
    if (!sel) return;

    const match = getMatchingPriceGroupOption(sel, groupRaw);
    if (!match) return;

    if (activePriceGroupLock) {
      clearInterval(activePriceGroupLock.interval);
      clearTimeout(activePriceGroupLock.timeout);
      activePriceGroupLock = null;
    }

    const wantedValue = match.value;

    function forceBackToWanted() {
      if (!document.contains(sel)) return;

      if (sel.value !== wantedValue) {
        sel.value = wantedValue;
        fireChange(sel);
      }
    }

    forceBackToWanted();

    const interval = setInterval(forceBackToWanted, 25);

    const timeout = setTimeout(function () {
      clearInterval(interval);
      activePriceGroupLock = null;
    }, 1000);

    activePriceGroupLock = {
      select: sel,
      wantedValue: wantedValue,
      interval: interval,
      timeout: timeout
    };
  }

  function markSelectedSwatch(swatchEl) {
    const wrapper = swatchEl.closest(WRAPPER_SEL);
    if (!wrapper) return;

    wrapper.querySelectorAll("a.fabric-item.is-selected").forEach(function (a) {
      a.classList.remove("is-selected");
      a.removeAttribute("aria-current");
    });

    swatchEl.classList.add("is-selected");
    swatchEl.setAttribute("aria-current", "true");
  }

  function fillChosenImgFabric(swatchEl) {
    if (!swatchEl) return false;

    const chosenImg = document.querySelector(CHOSEN_FABRIC_SWATCH);
    const chosenLabelEl = document.querySelector(CHOSEN_FABRIC);

    const thumb =
      swatchEl.dataset.fabricThumbnail ||
      swatchEl.querySelector("img")?.getAttribute("src") ||
      "";

    const fabricName =
      (swatchEl.dataset.fabricName || swatchEl.dataset.value || "").trim();

    if (chosenImg) {
      if (thumb) {
        chosenImg.src = thumb;
        chosenImg.alt = fabricName || "Selected fabric";
        chosenImg.removeAttribute("hidden");
        if (chosenImg.style) chosenImg.style.display = "";
      } else {
        chosenImg.setAttribute("hidden", "hidden");
        if (chosenImg.style) chosenImg.style.display = "none";
      }
    }

    if (chosenLabelEl) {
      chosenLabelEl.textContent = fabricName;
    }

    return true;
  }

  function fillHiddenInputsFromSwatch(scope, swatchEl) {
    const fabricName = swatchEl.dataset.fabricName || swatchEl.dataset.value || "";

    const thumb =
      swatchEl.dataset.fabricThumbnail ||
      swatchEl.querySelector("img")?.getAttribute("src") ||
      "";

    const code =
      swatchEl.dataset.rawFabricName ||
      swatchEl.querySelector(".color-code")?.textContent?.trim() ||
      "";

    const iFabric = scope.querySelector(H_FABRIC) || document.querySelector(H_FABRIC);
    const iThumb  = scope.querySelector(H_THUMB) || document.querySelector(H_THUMB);
    const iCode   = scope.querySelector(H_CODE) || document.querySelector(H_CODE);

    if (iFabric) iFabric.value = fabricName;
    if (iThumb)  iThumb.value  = thumb;
    if (iCode)   iCode.value   = code;
  }

  function getSelectedFabricSwatch(scope) {
    return (
      scope.querySelector(`${WRAPPER_SEL} a.fabric-item.is-selected[data-price-group]`) ||
      document.querySelector(`${WRAPPER_SEL} a.fabric-item.is-selected[data-price-group]`)
    );
  }

  function getCurrentPriceGroup(scope) {
    const sel = findPriceGroupSelect(scope);
    if (!sel) return "";

    const selectedOption = sel.options[sel.selectedIndex];

    return normalize(
      selectedOption?.textContent ||
      selectedOption?.value ||
      ""
    );
  }

  function priceGroupMatches(scope, groupRaw) {
    const wanted = normalize(groupRaw);
    if (!wanted) return false;

    const current = getCurrentPriceGroup(scope);

    return (
      current === wanted ||
      current === `PRICE GROUP ${wanted}` ||
      current.endsWith(` ${wanted}`)
    );
  }

  function temporarilyDisableAddToCart(scope) {
    const submitBtn =
      scope.querySelector('button[name="add"]') ||
      scope.querySelector('[type="submit"]');

    if (!submitBtn) return;

    submitBtn.disabled = true;

    setTimeout(function () {
      submitBtn.disabled = false;
    }, 300);
  }

  document.addEventListener("click", function (e) {
    const swatch = e.target.closest(SWATCH_SEL);
    if (!swatch) return;

    e.preventDefault();

    const scope = getScope(swatch);
    const pg = swatch.dataset.priceGroup;

    const okNow = setPriceGroup(scope, pg);

    lockPriceGroupAfterFabricClick(scope, pg);
    temporarilyDisableAddToCart(scope);

    fillHiddenInputsFromSwatch(scope, swatch);
    markSelectedSwatch(swatch);
    fillChosenImgFabric(swatch);

    setTimeout(function () {
      if (!priceGroupIsCorrect(scope, pg)) {
        setPriceGroup(scope, pg);
      }
    }, 1200);

    if (!okNow) {
      console.warn("[Fabrics] Price Group select not found or option missing for:", pg);
    }
  }, true);

  document.addEventListener("submit", function (e) {
    const form = e.target.closest('form[action^="/cart/add"]');
    if (!form) return;

    if (form.dataset.fabricPriceGroupFixing === "true") {
      delete form.dataset.fabricPriceGroupFixing;
      return;
    }

    const scope = getScope(form);
    const selectedSwatch = getSelectedFabricSwatch(scope);

    if (!selectedSwatch) return;

    const wantedGroup = selectedSwatch.dataset.priceGroup;

    if (priceGroupMatches(scope, wantedGroup)) {
      return;
    }

    e.preventDefault();
    e.stopImmediatePropagation();

    const changed = setPriceGroup(scope, wantedGroup);

    if (!changed) {
      alert("Please re-select your fabric before adding this item to cart.");
      return;
    }

    lockPriceGroupAfterFabricClick(scope, wantedGroup);

    form.dataset.fabricPriceGroupFixing = "true";

    setTimeout(function () {
      if (form.requestSubmit) {
        form.requestSubmit();
      } else {
        form.submit();
      }
    }, 200);
  }, true);
})();


(function () {
  // selectors/ids (keep your existing markup)
  var WRAP_ID = "rh-desktop-slider-buttons";
  var NEXT_SEL = ".rh-slider-desktop-next";
  var PREV_SEL = ".rh-slider-desktop-prev";

  var MAIN_UL_SEL = "ul.rh-product-slider-ul";
  var MAIN_LI_SEL = "li.product__media-item";

  var THUMB_UL_ID = "rh-product-slider-thumb";
  var THUMB_LI_SEL = 'li[data-target]';

  var COUNTER_WRAP_ID = "rh-desktop-slider-counter-caption";
  var COUNTER_CURRENT_SEL = ".rh-desktop-slider-counter-current";

  // bind once
  if (document.documentElement.dataset.rhDesktopSliderBound === "1") return;
  document.documentElement.dataset.rhDesktopSliderBound = "1";

  function esc(s) {
    if (window.CSS && CSS.escape) return CSS.escape(String(s));
    return String(s).replace(/["\\]/g, "\\$&");
  }

  function getScope(el) {
    return (
      el.closest('form[action^="/cart/add"]') ||
      el.closest(".product__info-wrapper") ||
      el.closest('section[id^="shopify-section-"]') ||
      document
    );
  }

  function qsInScope(scope, sel) {
    return (scope && scope.querySelector) ? scope.querySelector(sel) : null;
  }

  function getWrapFrom(el) {
    var scope = getScope(el);
    // IMPORTANT: in combined listings IDs can be duplicated; scope-first lookup avoids grabbing the wrong one
    return qsInScope(scope, "#" + esc(WRAP_ID)) || document.getElementById(WRAP_ID);
  }

  function getMainUl(scope) {
    return qsInScope(scope, MAIN_UL_SEL);
  }

  function getMainLis(scope) {
    var ul = getMainUl(scope);
    if (!ul) return [];
    return Array.prototype.slice.call(ul.querySelectorAll(MAIN_LI_SEL));
  }

  function getThumbUl(scope) {
    return qsInScope(scope, "#" + esc(THUMB_UL_ID)) || document.getElementById(THUMB_UL_ID);
  }

  function setCounter(scope, pos) {
    var wrap = qsInScope(scope, "#" + esc(COUNTER_WRAP_ID)) || document.getElementById(COUNTER_WRAP_ID);
    if (!wrap) return;
    var el = wrap.querySelector(COUNTER_CURRENT_SEL);
    if (el) el.textContent = String(pos);
  }

  function setMainActiveByMediaId(scope, mediaId) {
    if (!mediaId) return;

    var ul = getMainUl(scope);
    if (!ul) return;

    var prev = ul.querySelector("li.is-active");
    if (prev) prev.classList.remove("is-active");

    var next = ul.querySelector('li.product__media-item[data-media-id="' + esc(mediaId) + '"]');
    if (next) next.classList.add("is-active");
  }

  function setThumbActiveByTarget(scope, targetId) {
    var thumbUl = getThumbUl(scope);
    if (!thumbUl || !targetId) return;

    var prev = thumbUl.querySelector("li.rh-active");
    if (prev) prev.classList.remove("rh-active");

    var next = thumbUl.querySelector('li[data-target="' + esc(targetId) + '"]');
    if (!next) return;

    next.classList.add("rh-active");

    var pos = next.getAttribute("data-media-position");
    if (pos) setCounter(scope, pos);
  }

  function syncThumbFromActiveSlide(scope) {
    var ul = getMainUl(scope);
    if (!ul) return;

    var activeSlide = ul.querySelector("li.is-active");
    if (!activeSlide) return;

    var mediaId = activeSlide.getAttribute("data-media-id");
    if (!mediaId) return;

    setThumbActiveByTarget(scope, mediaId);
  }

  function move(scope, dir) {
    var lis = getMainLis(scope);
    if (!lis.length) return;

    var ul = getMainUl(scope);
    if (!ul) return;

    var active = ul.querySelector("li.is-active");
    var idx = active ? lis.indexOf(active) : -1;

    if (idx === -1) {
      lis[0].classList.add("is-active");
      syncThumbFromActiveSlide(scope);
      return;
    }

    var nextIdx = dir === "next" ? idx + 1 : idx - 1;

    // no looping
    if (nextIdx < 0 || nextIdx >= lis.length) return;

    lis[idx].classList.remove("is-active");
    lis[nextIdx].classList.add("is-active");

    syncThumbFromActiveSlide(scope);
  }

  // ONE click handler for everything (survives re-render)
  document.addEventListener(
    "click",
    function (e) {
      var t = e.target;

      // NEXT/PREV buttons
      var nextBtn = t.closest("#" + esc(WRAP_ID) + " " + NEXT_SEL);
      var prevBtn = t.closest("#" + esc(WRAP_ID) + " " + PREV_SEL);

      if (nextBtn || prevBtn) {
        e.preventDefault();

        var wrap = getWrapFrom(t);
        if (!wrap) return;

        var scope = getScope(wrap);
        move(scope, nextBtn ? "next" : "prev");
        return;
      }

      // Thumb click
      var thumbLi = t.closest("#" + esc(THUMB_UL_ID) + " " + THUMB_LI_SEL);
      if (thumbLi) {
        e.preventDefault();

        var scope2 = getScope(thumbLi);
        var targetId = thumbLi.getAttribute("data-target");
        if (!targetId) return;

        setThumbActiveByTarget(scope2, targetId);
        setMainActiveByMediaId(scope2, targetId);
      }
    },
    true // capture helps if other scripts stopPropagation
  );

  // Initial sync (and safe to re-run later)
  function initAll() {
    var wraps = document.querySelectorAll("#" + esc(WRAP_ID));
    wraps.forEach(function (wrap) {
      var scope = getScope(wrap);
      syncThumbFromActiveSlide(scope);
    });
  }

  initAll();

  // Re-init after Shopify section refreshes (combined listings often triggers these)
  document.addEventListener("shopify:section:load", initAll);
  document.addEventListener("shopify:section:reorder", initAll);
})();




/* Toggle "hidden" on #shipping-accordion-wrapper when #shipping-accordion is clicked (works with Combined Listings) */
(function () {
  const TRIGGER_SEL = "#shipping-accordion";
  const WRAPPER_SEL = "#shipping-accordion-wrapper";

  function getScope(el) {
    // try to keep it inside the current product area
    return (
      el.closest('form[action^="/cart/add"]') ||
      el.closest(".product__info-wrapper") ||
      el.closest('section[id^="shopify-section-"]') ||
      document
    );
  }

  document.addEventListener(
    "click",
    function (e) {
      const trigger = e.target.closest(TRIGGER_SEL);
      if (!trigger) return;

      // If your trigger is an <a href="#">, prevent jump
      if (trigger.tagName === "A") e.preventDefault();

      const scope = getScope(trigger);
      const wrapper = scope.querySelector(WRAPPER_SEL) || document.querySelector(WRAPPER_SEL);
      if (!wrapper) return;

      wrapper.classList.toggle("hidden");
    },
    true // capture helps when other scripts stopPropagation
  );
})();




/* =========================================================
   1) DESKTOP TABS (LI): #pd-tabs-buttons li[data-tn]
      - adds/removes .hide-desktop on PANELS
      - toggles .active on LI buttons
      - does NOT touch mobile hide classes
   ========================================================= */
(function () {
  const TAB_LIST_SEL = "#pd-tabs-buttons";
  const TAB_SEL = "li[data-tn]";
  const HIDE_DESKTOP = "hide-desktop";

  function getScope(el) {
    return (
      el.closest('form[action^="/cart/add"]') ||
      el.closest(".product__info-wrapper") ||
      el.closest('section[id^="shopify-section-"]') ||
      document
    );
  }

  function getTabListFrom(el) {
    // prefer the closest list (prevents wrong list in Combined Listings)
    return el.closest(TAB_LIST_SEL) || getScope(el).querySelector(TAB_LIST_SEL) || document.querySelector(TAB_LIST_SEL);
  }

  function escId(id) {
    if (!id) return "";
    if (window.CSS && CSS.escape) return CSS.escape(String(id));
    return String(id).replace(/["\\]/g, "\\$&");
  }

  function findPanel(scope, id) {
    if (!id) return null;
    const safe = escId(id);
    return scope.querySelector(`#${safe}`) || document.getElementById(id);
  }

  function activateDesktopTab(tabList, nextLi) {
    if (!tabList || !nextLi) return;

    const scope = getScope(tabList);
    const tabs = Array.from(tabList.querySelectorAll(TAB_SEL));
    const nextId = nextLi.dataset.tn;
    if (!nextId) return;

    // LI active state (desktop buttons)
    tabs.forEach((li) => li.classList.toggle("active", li === nextLi));

    // Panels: add hide-desktop to all, remove from selected
    tabs.forEach((li) => {
      const id = li.dataset.tn;
      const panel = findPanel(scope, id);
      if (!panel) return;
      panel.classList.add(HIDE_DESKTOP);
    });

    const nextPanel = findPanel(scope, nextId);
    if (nextPanel) nextPanel.classList.remove(HIDE_DESKTOP);
  }

  // Bind ONCE
  if (document.documentElement.dataset.rhDesktopTabsBound === "1") return;
  document.documentElement.dataset.rhDesktopTabsBound = "1";

  document.addEventListener(
    "click",
    function (e) {
      const li = e.target.closest(`${TAB_LIST_SEL} ${TAB_SEL}`);
      if (!li) return;

      const tabList = getTabListFrom(li);
      if (!tabList) return;

      activateDesktopTab(tabList, li);
    },
    true
  );

  function initDesktopTabs(root) {
    const container = root || document;

    container.querySelectorAll(TAB_LIST_SEL).forEach((tabList) => {
      const scope = getScope(tabList);
      const tabs = Array.from(tabList.querySelectorAll(TAB_SEL));
      if (!tabs.length) return;

      // Hide all panels on desktop by default
      tabs.forEach((li) => {
        const p = findPanel(scope, li.dataset.tn);
        if (p) p.classList.add(HIDE_DESKTOP);
      });

      // Show active (or first)
      const initial = tabList.querySelector("li.active[data-tn]") || tabs[0];
      if (initial) {
        const initialPanel = findPanel(scope, initial.dataset.tn);
        if (initialPanel) initialPanel.classList.remove(HIDE_DESKTOP);
        tabs.forEach((li) => li.classList.toggle("active", li === initial));
      }
    });
  }

  initDesktopTabs(document);
  document.addEventListener("shopify:section:load", (e) => initDesktopTabs(e.target));
  document.addEventListener("shopify:section:reorder", (e) => initDesktopTabs(e.target));
})();

/* =========================================================
   2) MOBILE HEADER TOGGLES (DIV headers):
      - toggles .hide-mobile on PANELS
      - toggles .active on the HEADER you clicked
      - does NOT touch LI buttons
      - does NOT touch .hide-desktop
   ========================================================= */
(function () {
  const HEADER_SEL = ".rh-product-informations-h[data-tn]";
  const HIDE_MOBILE = "hide-mobile"; // <- make sure your CSS uses this class on mobile

  function getScope(el) {
    return (
      el.closest('form[action^="/cart/add"]') ||
      el.closest(".product__info-wrapper") ||
      el.closest('section[id^="shopify-section-"]') ||
      document
    );
  }

  function escId(id) {
    if (!id) return "";
    if (window.CSS && CSS.escape) return CSS.escape(String(id));
    return String(id).replace(/["\\]/g, "\\$&");
  }

  function findPanel(scope, id) {
    if (!id) return null;
    const safe = escId(id);
    return scope.querySelector(`#${safe}`) || document.getElementById(id);
  }

  function toggleMobilePanel(header) {
    const scope = getScope(header);
    const id = header.dataset.tn;
    if (!id) return;

    const panel = findPanel(scope, id);
    if (!panel) return;

    const willOpen = panel.classList.contains(HIDE_MOBILE);

    // Toggle only this panel for mobile
    panel.classList.toggle(HIDE_MOBILE, !willOpen);

    // Toggle only this header active state
    header.classList.toggle("active", willOpen);
  }

  // Bind ONCE
  if (document.documentElement.dataset.rhMobileHeadersBound === "1") return;
  document.documentElement.dataset.rhMobileHeadersBound = "1";

  document.addEventListener(
    "click",
    function (e) {
      const header = e.target.closest(HEADER_SEL);
      if (!header) return;
      toggleMobilePanel(header);
    },
    true
  );
})();


(function () {
  function init(root) {
    if (!root || root.dataset.rhBound === "1") return;
    root.dataset.rhBound = "1";

    function sync(selectEl) {
      var wrap = selectEl.closest(".rh-addon");
      if (!wrap) return;

      var hidden = wrap.querySelector("input[data-rh-addon-property]");
      if (!hidden) return;

      var val = (selectEl.value || "").trim();
      hidden.value = val;

      // Omit blank properties entirely (recommended):
      hidden.disabled = !val;
    }

    // Delegate within this root (fast + safe)
    root.addEventListener("change", function (e) {
      var sel = e.target;
      if (!sel || !sel.matches || !sel.matches("select[data-rh-addon-select]")) return;
      sync(sel);
    });

    // Initialize any existing selects
    var selects = root.querySelectorAll("select[data-rh-addon-select]");
    for (var i = 0; i < selects.length; i++) sync(selects[i]);
  }

  function boot(scope) {
    var ctx = scope || document;
    var roots = ctx.querySelectorAll("[data-rh-product-addons]");
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  // 1) Initial run
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { boot(document); });
  } else {
    boot(document);
  }

  // 2) Theme Editor / section reloads (covers a lot of dynamic swaps)
  document.addEventListener("shopify:section:load", function (e) {
    boot(e.target);
  });
  document.addEventListener("shopify:section:reorder", function (e) {
    boot(e.target);
  });

  // 3) Combined Listings / dynamic product swaps:
  // Watch for new nodes being injected and init only what’s new.
  var mo = new MutationObserver(function (mutations) {
    for (var m = 0; m < mutations.length; m++) {
      var added = mutations[m].addedNodes;
      if (!added || !added.length) continue;

      for (var n = 0; n < added.length; n++) {
        var node = added[n];
        if (!node || node.nodeType !== 1) continue; // element only

        // If the added node IS an addons root
        if (node.matches && node.matches("[data-rh-product-addons]")) {
          init(node);
          continue;
        }

        // Or contains one (common when entire product form swaps)
        if (node.querySelector) {
          var roots = node.querySelectorAll("[data-rh-product-addons]");
          for (var i = 0; i < roots.length; i++) init(roots[i]);
        }
      }
    }
  });

  mo.observe(document.documentElement, { childList: true, subtree: true });
})();


// RH ADDON SWATCHES (simple + reliable)
// - Hover label: updates legend text
// - Mouseout: restores checked value
// - Click label: checks radio + updates hidden property + legend + .is-selected
// Works with your markup shown (fieldset with data-rh-addon-swatch-group, legend id rh-addon-<option>)

(function () {
  const GROUP_SEL = '[data-rh-addon-swatch-group]';
  const LABEL_SEL = 'label[data-rh-addon-option]';
  const RADIO_IN_LABEL_SEL = 'input[type="radio"][data-rh-addon-swatch]';
  const VALUE_SPAN_SEL = '[data-rh-addon-selected-value]';
  const HIDDEN_SEL = 'input[data-rh-addon-property]';

  function setLegend(optionName, text) {
    const legend = document.getElementById('rh-addon-' + optionName);
    if (!legend) return;
    const span = legend.querySelector(VALUE_SPAN_SEL);
    if (!span) return;
    span.textContent = text || '';
  }

  function setHidden(group, text) {
    const hidden = group.querySelector(HIDDEN_SEL);
    if (!hidden) return;
    hidden.value = text || '';
    hidden.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function setSelectedClasses(group, checkedRadio) {
    const name = checkedRadio && checkedRadio.name;
    if (!name) return;

    group.querySelectorAll(`input[type="radio"][name="${CSS.escape(name)}"]`).forEach((r) => {
      const label = r.closest(LABEL_SEL) || group.querySelector(`label[for="${CSS.escape(r.id)}"]`);
      if (label) label.classList.toggle('is-selected', r.checked);
    });
  }

  function getGroup(el) {
    return el.closest(GROUP_SEL) || el.closest('fieldset') || el.closest('.rh-addon__swatches');
  }

  function restoreChecked(group, optionName) {
    const checked =
      group.querySelector('input[type="radio"][data-rh-addon-swatch]:checked') ||
      group.querySelector('input[type="radio"][data-rh-addon-swatch]');
    if (!checked) return;
    checked.checked = true;
    setLegend(optionName, checked.value || '');
    setHidden(group, checked.value || '');
    setSelectedClasses(group, checked);
  }

  // Hover preview
  document.addEventListener(
    'mouseover',
    function (e) {
      const label = e.target.closest && e.target.closest(LABEL_SEL);
      if (!label) return;

      const optionName = label.getAttribute('data-rh-addon-option') || '';
      const input = label.querySelector(RADIO_IN_LABEL_SEL);
      if (!optionName || !input) return;

      setLegend(optionName, input.value || '');
    },
    true
  );

  // Restore on leave
  document.addEventListener(
    'mouseout',
    function (e) {
      const label = e.target.closest && e.target.closest(LABEL_SEL);
      if (!label) return;

      const group = getGroup(label);
      if (!group) return;

      const optionName = label.getAttribute('data-rh-addon-option') || '';
      if (!optionName) return;

      restoreChecked(group, optionName);
    },
    true
  );

  // Click to select
  document.addEventListener(
    'click',
    function (e) {
      const label = e.target.closest && e.target.closest(LABEL_SEL);
      if (!label) return;

      const group = getGroup(label);
      if (!group) return;

      const optionName = label.getAttribute('data-rh-addon-option') || '';
      const input = label.querySelector(RADIO_IN_LABEL_SEL);
      if (!optionName || !input) return;

      if (!input.checked) input.checked = true;

      setLegend(optionName, input.value || '');
      setHidden(group, input.value || '');
      setSelectedClasses(group, input);
    },
    true
  );

  // Init: make sure hidden + legend match checked on load
  document.querySelectorAll(GROUP_SEL).forEach((group) => {
    const anyLabel = group.querySelector(LABEL_SEL);
    const optionName = anyLabel ? anyLabel.getAttribute('data-rh-addon-option') : '';
    if (optionName) restoreChecked(group, optionName);
  });
})();



	document.querySelector('#signup-save-pdpatc').addEventListener('click', function (){
		window._klOnsite = window._klOnsite || []; 
		window._klOnsite.push(['openForm', 'Xtt7KD']);
	});


  
  // Combined listing connecting dropdown

if (!window.__rhClSelectBound) {
  window.__rhClSelectBound = true;

  document.addEventListener('change', (e) => {
    const el = e.target;
    if (!(el instanceof HTMLSelectElement)) return;
    if (!el.matches('.cl-connect-dropdown [data-cl-select]')) return;

    const url = el.value;
    if (url) window.location.assign(url);
  });
}